import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { Col, Container, Label, Row } from "reactstrap";
import { Btn, H2, H6, Image, P } from "../../AbstractElements";
import { dynamicImage } from "../../Service";
import Loader from "../../CommonElements/Loader/Loader";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useResetPasswordService } from "../../Service/Authentication/ForgotPassword";
import { useSweetAlert } from "../../Context/SweetAlertContext";
import { Href, SignInWith } from "../../utils/Constant";

// ---------------- Types ----------------
export interface ResetPasswordFormPropsType {
  Password: string;
  ConfirmPassword: string;
}

// ---------------- Initial Values ----------------
export const ResetPasswordFormInitialValues: ResetPasswordFormPropsType = {
  Password: "",
  ConfirmPassword: "",
};

// ---------------- Validation Schema ----------------
const ResetPasswordSchema = Yup.object().shape({
  Password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
  ConfirmPassword: Yup.string()
    .oneOf([Yup.ref("Password"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

// ---------------- Component ----------------
const ResetPassword = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const { doResetPassword, checkTokenValidity, loading } = useResetPasswordService();
  const navigate = useNavigate();
  const { ShowSuccessAlert, showAlert } = useSweetAlert();

  // 🔹 Check token validity on mount
  useEffect(() => {
    // checkToken();
  }, []);

  // const checkToken = async () => {
  //   if (token) {
  //     const res = await checkTokenValidity({
  //       procName: "ResetPassword",
  //       Para: `{"ActionMode":"CheckTokenValidity","RandomKey":"${token}"}`,
  //     });
  //     if (!res) return;
  //     if (res[0]?.StatusCode !== "1") {
  //       showAlert(res[0]?.Msg || "Invalid token");
  //       setTimeout(() => {
  //         navigate(`${import.meta.env.BASE_URL}/login`);
  //       }, 2000);
  //     }
  //   } else {
  //     showAlert("Invalid Token, Try again");
  //     navigate(`${import.meta.env.BASE_URL}/login`);
  //   }
  // };

  // const HandleSubmit = async (values: ResetPasswordFormPropsType) => {
  //   if (!token) {
  //     showAlert("Invalid Token, Try again");
  //     return;
  //   }

  //   const { Password } = values;
  //   const obj = { Password, Token: token };

  //   const res = await doResetPassword(obj);
  //   if (!res) return;

  //   if (res[0]?.StatusCode == "1") {
  //     ShowSuccessAlert(res[0].Msg);
  //     setTimeout(() => {
  //       navigate(`${import.meta.env.BASE_URL}/login`);
  //     }, 3000);
  //   } else {
  //     toast.error(res[0]?.Msg || "Password reset failed");
  //   }
  // };

  return (
    <Container fluid className="p-0">
      {loading && <Loader />}
      <Row className="m-0">
        <Col xs="12" className="p-0">
          <div className="login-card login-dark" style={{ backgroundColor: "transparent" }}>
            <div>
              <div className="login-main" style={{ boxShadow: "0px 1px 20px 0px #f8dca6" }}>
                <div>
                  <Link className="logo text-center" to={Href}>
                    <Image
                      className="img-fluid"
                      src={dynamicImage("login/suknyalogo.png")}
                      style={{ height: "90px" }}
                      alt="logo"
                    />
                  </Link>
                </div>

                <Formik
                  initialValues={ResetPasswordFormInitialValues}
                  validationSchema={ResetPasswordSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    HandleSubmit(values);
                    setSubmitting(false);
                  }}
                >
                  {({ isSubmitting }) => (
                    <Form className="theme-form">
                      <H2 className="text-center mt-1">Reset Password</H2>
                      <P className="text-center">
                        {"Enter your new password and confirm it below"}
                      </P>

                      <div className="form-group">
                        <Label className="col-form-label">Password</Label>
                        <Field
                          type="password"
                          name="Password"
                          placeholder="Enter Password"
                          className="form-control"
                        />
                        <ErrorMessage name="Password" component="div" className="text-danger" />
                      </div>

                      <div className="form-group">
                        <Label className="col-form-label">Confirm Password</Label>
                        <Field
                          type="password"
                          name="ConfirmPassword"
                          placeholder="Re-enter Password"
                          className="form-control"
                        />
                        <ErrorMessage name="ConfirmPassword" component="div" className="text-danger" />
                      </div>

                      <div className="form-group mb-0 checkbox-checked">
                        <div className="text-end mt-3">
                          <Btn
                            color="primary"
                            block
                            className="w-100 rounded-4 py-2 fw-bold"
                            type="submit"
                            disabled={isSubmitting}
                          >
                            Submit
                          </Btn>
                        </div>
                      </div>

                      <div className="login-social-title">
                        <H6>{SignInWith}</H6>
                      </div>
                      <P className="mt-4 mb-0 text-center">
                        <Link
                          className="ms-2"
                          style={{ color: "#d0b163" }}
                          to={`${import.meta.env.BASE_URL}/login`}
                        >
                          Back to Login
                        </Link>
                      </P>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ResetPassword;
